import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import StyledButton from '../../../../common/models/Button';
import Dialog from '@material-ui/core/Dialog';
import DropFilesAttach from '../models/files/DropFilesAttach';
import InputNumber from '../models/inputs/InputNumber';
import DuplicateFileNamePrompt from '../updateGrRecord/DuplicateFilePrompt';
import ShowFiles from '../updateGrRecord/ShowFiles';

const useStyles = makeStyles((theme) => ({
  font: {
    fontWeight: 500,
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  padding: {
    paddingBottom: '2rem',
  },
}));

const OtherInfo = (props) => {
  const classes = useStyles();
  const {
    qaInfoData,
    handleChange,
    isAddRecord,
    //parent
    parentHandlingDeleteFile,
    OtherInfoTempNumber,
  } = props;

  // const [otherInformationRemarks, setOtherInformation] = React.useState(
  //   qaInfoData?.otherInformationRemarks || ''
  // );
  const [otherFiles, setOtherFiles] = React.useState(qaInfoData?.otherFiles);

  //file append
  const [tempNumber, setTempNumber] = React.useState(OtherInfoTempNumber);
  // const [localTempNumber, setLocalTempNumber] =
  //   React.useState(OtherInfoTempNumber);

  const [dupFilePrompt, setDupFilePrompt] = React.useState(false);

  useEffect(() => {
    if (Array.isArray(qaInfoData?.otherFiles)) {
      setOtherFiles([...qaInfoData.otherFiles]);
    }
  }, [qaInfoData?.otherFiles]);

  const filePrompt = () => {
    setDupFilePrompt(true);
  };

  const handleFileCopy = () => {
    setDupFilePrompt(false);
  };

  const handleClose = () => {
    setDupFilePrompt(false);
  };

  // const localFileHandling = (files) => {
  //   console.log(files);
  //   files.forEach((file) => {
  //     const reader = new FileReader();

  //     reader.readAsDataURL(file);
  //     reader.onabort = () => console.log('file reading was aborted');
  //     reader.onerror = () => console.log('file reading has failed');
  //     reader.onload = () => {
  //       let newFileName = file.name;

  //       let counter = otherFiles
  //         .map((file) => file.grFileName)
  //         .indexOf(file.name);

  //       if (counter > -1) {
  //         filePrompt();
  //         // counter > -1 means the name is already taken
  //         // We split with . to deal with the extension
  //         newFileName = `${file.name.split('.')[0]}_${localTempNumber + 1}.${
  //           file.name.split('.')[1]
  //         }`;
  //         setLocalTempNumber(localTempNumber + 1);
  //       }

  //       // Do whatever you want with the file contents
  //       const fileData = {
  //         grFileData: reader.result,
  //         grFileName: newFileName,
  //         grFileType: 'buffer',
  //         schrockenGRFileId: '',
  //         grFileHash: '',
  //         markForDelete: false,
  //       };
  //       console.log('fileData', fileData);
  //       setOtherFiles((prevFiles) => [...prevFiles, fileData]);
  //     };
  //   });
  // };

  console.log('otherFiles', otherFiles);

  const fileHandling = (files) => {
    console.log(files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        let newFileName = file.name;

        let counter = qaInfoData?.otherFiles
          ? qaInfoData.otherFiles
              .map((file) => file.grFileName)
              .indexOf(file.name)
          : -1;

        if (counter > -1) {
          filePrompt();
          // counter > -1 means the name is already taken
          // We split with . to deal with the extension
          newFileName = `${file.name.split('.')[0]}_${tempNumber + 1}.${
            file.name.split('.')[1]
          }`;

          props.handleTempNumber('OtherInfoTempNumber');
          setTempNumber(tempNumber + 1);
        }

        // Do whatever you want with the file contents
        const newArr = {
          grFileData: reader.result,
          grFileName: newFileName,
          grFileType: 'buffer',
          schrockenGRFileId: '',
          grFileHash: '',
          markForDelete: false,
        };
        console.log('newArr', newArr);
        props.handlingFiles(newArr, 'otherFiles');
      };
    });
  };

  const handlingDeleteFile = (i) => {
    // for rec fromBE=> mfd as 1, for local filter out
    //check for filetype in file
    //if 'buffer' then follow filter logic
    // if it is not buffer edit that file data sayn mfd 1
    if (
      window.confirm(
        'You are about to delete a file ,would you like to proceed ?'
      )
    ) {
      if (otherFiles[i].grFileType === 'buffer') {
        let newdel = otherFiles.filter(
          (file) => file.grFileName !== otherFiles[i].grFileName
        );
        setOtherFiles(newdel);
      } else {
        // otherFiles[i].markForDelete=1;
        let markDelFile = otherFiles.map((file) =>
          file.grFileHash === otherFiles[i].grFileHash
            ? { ...file, markForDelete: true }
            : file
        );
        setOtherFiles(markDelFile);
      }
    }
  };

  return (
    <React.Fragment>
      <Grid
        container
        justify='flex-start'
        spacing={8}
        className={classes.padding}
        // style={{ paddingTop: isAddRecord && '4rem' }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant='body2' className={classes.font}>
            Additional Remarks (optional)
          </Typography>
          <br />
          {isAddRecord ? (
            <InputNumber
              multiline
              rows={10}
              type='text'
              style={{ width: '100%' }}
              name='otherInformation'
              value={qaInfoData?.otherInformation}
              onChange={(e) => handleChange(e, 'otherInformation')}
              // value={
              //   isAddRecord !== true
              //     ? qaInfoData.otherInformationRemarks
              //     : otherInformationRemarks
              // }
              // onChange={
              //   isAddRecord !== true
              //     ? (e) => handleChange(e, 'otherInformationRemarks')
              //     : (e) => handleChangeInfo(e)
              // }
              placeholder='Enter Additional Remarks, if any'
              inputProps={{ maxLength: 255 }}
            />
          ) : (
            <Typography>{qaInfoData?.otherInformation}</Typography>
          )}
        </Grid>
      </Grid>

      {isAddRecord && (
        <Grid container justifyContent='center'>
          <Grid item xs={12} sm={12} md={12}>
            <DropFilesAttach
              // title='Additional File(s) (optional)'
              handleUploadFiles={(files) => fileHandling(files)}
              // handleUploadFiles={
              //   isAddRecord !== true
              //     ? (files) => fileHandling(files)
              //     : (files) => localFileHandling(files)
              // }
            />
            <Typography variant='body2' className={classes.font}>
              Additional File(s) (optional)
            </Typography>
          </Grid>
        </Grid>
      )}

      <Grid container className={classes.padding}>
        <Grid item xs={12} sm={6} md={6}>
          <Typography variant='body2' className={classes.font}>
            Uploaded Document List
          </Typography>

          <ShowFiles
            files={qaInfoData?.otherFiles}
            handlingDeleteFile={parentHandlingDeleteFile}
            name='otherFiles'
            isUploadFile={isAddRecord}
          />
        </Grid>
      </Grid>

      <Dialog open={dupFilePrompt} fullWidth>
        <DuplicateFileNamePrompt
          handleYesButton={handleFileCopy}
          handleClose={handleClose}
        />
      </Dialog>
    </React.Fragment>
  );
};

export default OtherInfo;
